export default "__VITE_ASSET__Cy2hh9OD__"